import { isNil } from 'lodash';
import { DECIMAL_PLACES } from 'common/config/app';
import { dbShortDate } from 'utilities/dateFormats';
import { ParseFieldValue } from './types';

const parseFieldValue: ParseFieldValue = params => {
  const { decimalPlaces = DECIMAL_PLACES, type, value } = params;

  if (isNil(value)) {
    return null;
  }

  switch (type) {
    case 'DecimalField': {
      const numberValue = Number(value);

      if (Number.isNaN(numberValue)) {
        return null;
      }

      return Number(numberValue.toFixed(decimalPlaces));
    }

    case 'IntegerField':
    case 'SmallIntegerField': {
      const numberValue = Number(value);

      if (Number.isNaN(numberValue)) {
        return null;
      }

      return Math.trunc(numberValue);
    }

    case 'BooleanField':
      if (typeof value === 'boolean') {
        return value;
      }
      if (typeof value === 'string') {
        return Boolean(Number(value));
      }

      return Boolean(value);

    case 'DateField':
    case 'DateTimeField':
      return dbShortDate(value as string);

    case 'TextField':
      return String(value);

    default:
      return value;
  }
};

export default parseFieldValue;
